import { capitalize } from "lodash";

export const getIntensityDisplayText = (intensity) => {
  switch (intensity) {
    case "light":
      return "Easy";
    case "moderate":
      return "Normal";
    case "intense":
      return "Strict";
    default:
      return "Normal";
  }
};

export const getGradingLengthDisplayText = (length) => {
  switch (length) {
    case "long":
      return "Detailed";
    case "normal":
      return "Medium";
    case "concise":
      return "Short";
    default:
      return "Medium";
  }
};

export const formatDefaultType = (essay) => {
  if (!essay) {
    return "";
  }

  let str = "";

  if (essay.gradeLevel) {
    str += capitalize(essay.gradeLevel.trim());
  }

  if (essay.type) {
    str += `${str.length > 0 ? " - " : ""}${capitalize(essay.type.trim())}`;
  }

  return str.trim();
};

export function formatAuthorValue(value, $store) {
  if (!value) {
    return "EssayGrader";
  }

  if (typeof value === "object") {
    if ($store?.state?.user?.id && value.id === $store?.state?.user?.id) {
      return "Me";
    }

    return value.firstName + " " + value.lastName;
  }

  return value;
}

export function formatTimeSaved(seconds) {
  if (!seconds || seconds < 0) {
    return "0 secs";
  }

  // If less than 60 seconds, show in seconds
  if (seconds < 60) {
    return `${Math.round(seconds)} secs`;
  }

  // If less than 3600 seconds (1 hour), show in minutes
  if (seconds < 3600) {
    const minutes = Math.round(seconds / 60);
    return `${minutes} mins`;
  }

  // If 3600 seconds or more, show in hours
  const hours = (seconds / 3600).toFixed(1);
  return `${hours} hrs`;
}

/**
 * Format number with thousands separators (comma)
 * @param {number} unformattedNumber - The number to format
 * @returns {string} Formatted number (e.g., "944", "1,234", "10,000")
 */
export function formatNumber(unformattedNumber) {
  const number = Number(unformattedNumber);

  if (!number && number !== 0) {
    return "0";
  }

  return number.toLocaleString("en-US");
}
